module.exports = __webpack_public_path__ + "static/media/replace-vehicle-red.7756ecdb.svg";